import { takeEvery, call, put, delay, select, fork, takeLatest, all  } from "redux-saga/effects";
import { push } from 'connected-react-router';
import { config  } from "../config/config";
import { authHeader } from "../utils/authHeader";
import { openAlert, openSuccessAlert, openErrorAlert, closeAlert, errorGradient, successGradient } from "../actions/dialogActions";




export default function* rootSaga() {

    yield takeEvery("LOGIN_USER", loginWorker);
    yield takeEvery("LOGOUT_USER", logoutWorker);

    yield takeEvery("GET_LOGS", getLogsWorker);
    yield takeEvery("GET_RUNNING_CHALLENGES", getRunningChallengesWorker);
    yield takeEvery("GET_FINISHED_CHALLENGES", getFinishedChallengesWorker);
    yield takeEvery("GET_AVAILABLE_CHALLENGES", getAvailableChallengesWorker);
    yield takeEvery("GET_CHALLENGE", getChallengeWorker);
    yield takeEvery("UPDATE_CHALLENGE", updateChallengeWorker);
    yield takeEvery("UPDATE_PARTICIPANT_SCORE", updateParticipantScoreWorker);
    yield takeEvery("CANCEL_CHALLENGE_JOB", cancelChallengeWorker);
    yield takeEvery("GET_GENERAL_STATISTICS", getGeneralStatisticsWorker);
    yield takeEvery("GET_USERS", getUsersWorker);
    yield takeEvery("GET_USER", getUserWorker);
    yield takeEvery("GIVE_USER_PROMOTION", givePromotionWorker);
    yield takeEvery("UPDATE_USER", updateUserWorker);
    yield takeEvery("GET_SERVICE_STATUS", getServiceStatusWorker);
    yield takeEvery("SET_SERVICE_TEXT", setServiceTextWorker);
    yield takeEvery("SET_SERVICE_STATUS", setServiceStatusWorker);

    yield takeEvery("GET_PAYMENTS", getPaymentsWorker);
    yield takeEvery("GET_WITHDRAWALS", getWithdrawalsWorker);
    yield takeEvery("UPDATE_WITHDRAWAL", updateWithdrawalWorker);

    yield takeEvery("CREATE_CASH_DISCOUNT_CODE", createDiscountCodeWorker);
    yield takeEvery("GET_DISCOUNT_CODES", getDiscountCodesWorker);
    yield takeEvery("UPDATE_DISCOUNT_CODE", updateDiscountCodeWorker);
    yield takeEvery("DELETE_DISCOUNT_CODE", deleteDiscountCodeWorker);

    yield takeEvery("BULK_ENROLL_CHALLENGE", bulkEnrollChallengeWorker);
    yield takeEvery("TEST_ENROLL_CHALLENGE", testEnrollChallengeWorker);
}



function* loginWorker(action) {
    console.log("login worker");

    try {
        yield put({ type: "IS_WORKING" });
        const { username, password } = action;
        const user = yield call(login, username, password);
        yield put({ type: "USER_LOGGED_IN", user });
        yield put(push('/', { refresh: true }))
    }
    catch (e) {
        console.log("Login failed," + e)
        yield put(openErrorAlert({ title: e.message}));
        yield put({ type: "LOGIN_FAILED", payload: e });
    }
}
function* getUsersWorker(action) {
    try {

        const users = yield call(getUsers);
        yield put({ type: "USERS", users: users });
    }
    catch (e) {
        console.log("Users failed," + e)
        yield put({ type: "GET_USERS_FAILED", payload: e });
    }
}

function* getUserWorker(action) {
    try {
        const { id } = action;
        const user = yield call(getUser,id);
        yield put({ type: "USER", user: user });
    }
    catch (e) {
        console.log("User failed," + e)
        yield put({ type: "GET_USER_FAILED", payload: e });
    }
}

function* updateUserWorker(action) {
    try {
        yield put({ type: "IS_WORKING" });
        const { values } = action;
        const user = yield call(updateUser, values);
        yield put({ type: "UPDATE_USER", user: user });
        yield put({ type: "FINISHED_WORKING" });
    }
    catch (e) {
        yield put({ type: "FINISHED_WORKING" });
        console.log("User failed," + e)
        yield put({ type: "UPDATE_USER_FAILED", payload: e });
    }
}

function* givePromotionWorker(action) {
    try {
        yield put({ type: "IS_WORKING" });
        const { id,amount } = action;
        const promotion = yield call(givePromotion, id, amount);
        yield put({ type: "PROMOTION", promotion: promotion });
        yield put({ type: "FINISHED_WORKING" });
        yield put(openSuccessAlert({ title: 'User was given $' +amount+ ". New amount is " + promotion.newAmount }));
    }
    catch (e) {
        yield put({ type: "FINISHED_WORKING" });
        console.log("Promotion failed," + e)
        yield put({ type: "PROMOTION_FAILED", payload: e });
    }
}

function* createDiscountCodeWorker(action) {
    try {
        yield put({ type: "IS_WORKING" });
        const { amount,description } = action;
        const discountCode = yield call(createDiscountCode, amount, description );
        yield put({ type: "DISCOUNT_CODE", discountCode: discountCode });
        yield put({ type: "FINISHED_WORKING" });
        yield put(openSuccessAlert({ title: 'Discount code "' + discountCode.code + '" created. Amount is $' + amount }));
    }
    catch (e) {
        yield put({ type: "FINISHED_WORKING" });
        console.log("Promotion failed," + e)
        yield put({ type: "DISCOUNT_CODE_FAILED", payload: e });
    }
}

function* getGeneralStatisticsWorker(action) {
    try {

        const general = yield call(getGeneralStatistics);
        yield put({ type: "GENERAL", general: general });
    }
    catch (e) {
        console.log("General failed," + e)
        yield put({ type: "GENERAL_FAILED", payload: e });
    }
}

function* getServiceStatusWorker(action) {
    try {

        const serviceStatus = yield call(getServiceStatus);
        yield put({ type: "SERVICE_STATUS", serviceStatus: serviceStatus });
    }
    catch (e) {
        console.log("service status failed," + e)
        yield put({ type: "SERVICE_STATUS_FAILED", payload: e });
    }
}


function* setServiceTextWorker(action) {

        const { text } = action;
        yield put({ type: "SERVICE_TEXT", text: text });
 }

function* setServiceStatusWorker(action){

    try {
        yield put({ type: "IS_WORKING"});
        const { allowJoinChallenge, allowChallengeToStart, botsEnabled, disturbanceMessage } = action;
        const serviceStatus = yield call(setServiceStatus, allowJoinChallenge, allowChallengeToStart, botsEnabled, disturbanceMessage)
        yield put({ type: "SERVICE_STATUS", serviceStatus: serviceStatus });
        yield put({ type: "FINISHED_WORKING" });
    }
    catch (e) {
        yield put({ type: "FINISHED_WORKING" });
        console.log("Set service status failed," + e)
        yield put({ type: "SET_SERVICE_STATUS_FAILED", payload: e });
    }
}

function* getLogsWorker(action) {
    try {

        const logs = yield call(getLogs);
        yield put({ type: "LOGS", logs: logs });
    }
    catch (e) {
        console.log("logs failed," + e)
        yield put({ type: "LOGS_FAILED", payload: e });
    }
}

function* getPaymentsWorker(action) {
    try {

        const payments = yield call(getPayments);
        yield put({ type: "PAYMENTS", payments: payments });
    }
    catch (e) {
        console.log("payments failed," + e)
        yield put({ type: "PAYMENTS_FAILED", payload: e });
    }
}

function* getWithdrawalsWorker(action) {
    try {

        const withdrawals = yield call(getWithdrawals);
        yield put({ type: "WITHDRAWALS", withdrawals: withdrawals });
    }
    catch (e) {
        console.log("withdrawals failed," + e)
        yield put({ type: "WITHDRAWALS_FAILED", payload: e });
    }
}

function* updateWithdrawalWorker(action) {
    try {

        const withdrawal = yield call(updateWithdrawal, action.id, action.status, action.reason);
        yield put({ type: "UPDATED_WITHDRAWAL", withdrawal: withdrawal });
        yield put({ type: "CLEAR_ERROR" });
    }
    catch (e) {
        console.log("update withdrawal failed," + e)
        yield put({ type: "UPDATE_WITHDRAWAL_FAILED", payload: e });
        yield put({ type: "SET_ERROR", errorMessage: e.message });

    }
}

function* getDiscountCodesWorker(action) {
    try {

        const discountCodes = yield call(getDiscountCodes);
        yield put({ type: "DISCOUNT_CODES", discountCodes: discountCodes });
    }
    catch (e) {
        console.log("discountCodes failed," + e)
        yield put({ type: "DISCOUNT_CODES_FAILED", payload: e });
    }
}

function* updateDiscountCodeWorker(action) {
    try {

        const updatedDiscountCode = yield call(updateDiscountCode, action.id, action.status, action.amount, action.description);
        yield put({ type: "UPDATED_DISCOUNT_CODE", updatedDiscountCode: updatedDiscountCode });
        yield put({ type: "CLEAR_ERROR" });
    }
    catch (e) {
        console.log("update discount code failed," + e)
        yield put({ type: "UPDATED_DISCOUNT_CODE_FAILED", payload: e });
        yield put({ type: "SET_ERROR", errorMessage: e.message });

    }
}

function* deleteDiscountCodeWorker(action) {
    try {

        const deletedDiscountCode = yield call(deleteDiscountCode, action.id);
        yield put({ type: "DELETED_DISCOUNT_CODE", deletedDiscountCode: deletedDiscountCode });
        yield put({ type: "CLEAR_ERROR" });
    }
    catch (e) {
        console.log("delted discount code failed," + e)
        yield put({ type: "DELETED_DISCOUNT_CODE_FAILED", payload: e });
        yield put({ type: "SET_ERROR", errorMessage: e.message });

    }
}

function* getRunningChallengesWorker(action) {
    try {

        const runningChallenges = yield call(getRunningChallenges);
        yield put({ type: "RUNNING_CHALLENGES", runningChallenges: runningChallenges });
    }
    catch (e) {
        console.log("runningChallenges failed," + e)
        yield put({ type: "RUNNING_CHALLENGES_FAILED", payload: e });
    }
}

function* getFinishedChallengesWorker(action) {
    try {

        const finishedChallenges = yield call(getFinishedChallenges);
        yield put({ type: "FINISHED_CHALLENGES", finishedChallenges: finishedChallenges });
    }
    catch (e) {
        console.log("finishedChallenges failed," + e)
        yield put({ type: "FINISHED_CHALLENGES_FAILED", payload: e });
    }
}

function* getAvailableChallengesWorker(action) {
    try {

        const availableChallenges = yield call(getAvailableChallenges);
        yield put({ type: "AVAILABLE_CHALLENGES", availableChallenges: availableChallenges });
    }
    catch (e) {
        console.log("availableChallenges failed," + e)
        yield put({ type: "AVAILABLE_CHALLENGES_FAILED", payload: e });
    }
}

function* getChallengeWorker(action) {
    try {

        const challenge = yield call(getChallenge,action.id);
        yield put({ type: "CHALLENGE", challenge: challenge });
    }
    catch (e) {
        console.log("get challenge failed," + e)
        yield put({ type: "CHALLENGE_FAILED", payload: e });
    }
}

function* updateChallengeWorker(action) {
    try {

        const challenge = yield call(updateChallenge, action.id, action.fee, action.maxParticipans, action.disabled);
        yield call(getAvailableChallengesWorker);
        yield put({ type: "CLEAR_ERROR" });
    }
    catch (e) {
        console.log("update challenge failed," + e)
        yield put({ type: "UPDATE_CHALLENGE_FAILED", payload: e });
        yield put({ type: "SET_ERROR", errorMessage: e.message });

    }
}

function* cancelChallengeWorker(action) {
    try {

        const challenge = yield call(cancelChallenge, action.id);
        yield put({ type: "CHALLENGE_CANCELED" });
    }
    catch (e) {
        console.log("cancelChallengeWorker failed," + e)
        yield put({ type: "CANCEL_CHALLENGE_FAILED", payload: e });
    }
}

function* testEnrollChallengeWorker(action) {
    try {
        yield put({ type: "IS_WORKING" });
        const result = yield call(testEnrollChallenge, action.id, action.email);
        yield put({ type: "FINISHED_WORKING" });

        if (result.enrolled) {
            yield put(openSuccessAlert({ title: `Enrolled ${result.email}` }));
        }
        else {
            yield put(openErrorAlert({ title: `Could not enroll ${result.email}: ${result.error || 'unknown'}` }));
        }

        yield call(getAvailableChallengesWorker);
    }
    catch (e) {
        yield put({ type: "FINISHED_WORKING" });
        console.log("testEnrollChallengeWorker failed," + JSON.stringify(e))
        yield put(openErrorAlert({ title: e.message || 'Test enroll failed' }));
        yield put({ type: "TEST_ENROLL_CHALLENGE_FAILED", payload: e });
    }
}

function* bulkEnrollChallengeWorker(action) {
    try {
        yield put({ type: "IS_WORKING" });
        const result = yield call(bulkEnrollChallenge, action.id);
        yield put({ type: "FINISHED_WORKING" });

        const failureNote = result.failedCount > 0
            ? ` (${result.failedCount} failed — see server logs)`
            : '';
        yield put(openSuccessAlert({
            title: `Enrolled ${result.enrolledCount}, skipped ${result.skippedCount}${failureNote}`
        }));

        yield call(getAvailableChallengesWorker);
    }
    catch (e) {
        yield put({ type: "FINISHED_WORKING" });
        console.log("bulkEnrollChallengeWorker failed," + JSON.stringify(e))
        yield put(openErrorAlert({ title: e.message || 'Bulk enroll failed' }));
        yield put({ type: "BULK_ENROLL_CHALLENGE_FAILED", payload: e });
    }
}

function* updateParticipantScoreWorker(action) {
    try {

        const challenge = yield call(updateParticipantScore, action.id, action.participantId, action.score);
        yield put({ type: "PARTICIPANT_SCORE_UPDATED" });
        yield put({ type: "CHALLENGE", challenge: challenge });
              
    }
    catch (e) {
        console.log("updateParticipantScoreWorker failed," + e)
        yield put({ type: "PARTICIPANT_SCORE_UPDATED_FAILED", payload: e });
    }
}


function* logoutWorker(action) {
    yield call(clearWorker);
    yield put(push('/'));
   
}

function* clearWorker(action) {
    yield call(logout);
    yield put({ type: "UNSUBSCRIBE_CHALLENGES" });
    yield put({ type: "LOGOUT" });
}

function getGeneralStatistics() {

    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/statistics/general`, requestOptions).then(handleResponse);
}

function getUsers() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/users`, requestOptions).then(handleResponse);
}

function getUser(id) {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/users/${id}`, requestOptions).then(handleResponse);
}

function updateUser(values) {
    console.log("Val=" + JSON.stringify(values));
    const requestOptions = {
        method: 'PUT',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify(values)
    };
    return fetch(`${config.url.BASE_URL}/api/management/users/${values.id}`, requestOptions).then(handleResponse);
}

function updateChallenge(id, fee, maxParticipans, disabled) {
    const requestOptions = {
        method: 'PUT',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ fee, maxParticipans, disabled })
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/${id}`, requestOptions).then(handleResponse);
}

function bulkEnrollChallenge(id) {
    const requestOptions = {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/${id}/bulk-enroll`, requestOptions).then(handleResponse);
}

function testEnrollChallenge(id, email) {
    const requestOptions = {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ email })
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/${id}/test-enroll`, requestOptions).then(handleResponse);
}

function givePromotion(id, amount) {
    const requestOptions = {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ amount })
    };
    return fetch(`${config.url.BASE_URL}/api/management/users/${id}/promotion`, requestOptions).then(handleResponse);
}

function createDiscountCode(amount, description) {
    const requestOptions = {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ amount, description })
    };
    return fetch(`${config.url.BASE_URL}/api/discounts/cash/issue`, requestOptions).then(handleResponse);
}

function getPayments() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/payments`, requestOptions).then(handleResponse);
}

function getWithdrawals() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/withdrawals`, requestOptions).then(handleResponse);
}

function updateWithdrawal(id, status, reason) {
    const requestOptions = {
        method: 'PUT',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ status, reason })
    };
    return fetch(`${config.url.BASE_URL}/api/management/withdrawals/${id}`, requestOptions).then(handleResponse);
}

function getDiscountCodes() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/discounts`, requestOptions).then(handleResponse);
}

function updateDiscountCode(id, status, amount, description) {
    const requestOptions = {
        method: 'PUT',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ status, amount, description })
    };
    return fetch(`${config.url.BASE_URL}/api/discounts/${id}`, requestOptions).then(handleResponse);
}

function deleteDiscountCode(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/discounts/${id}`, requestOptions).then(handleResponse);
}

function getLogs() {

    const ascending = false;

    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/logs/event?ascending=${ascending}`, requestOptions).then(handleResponse);
}

function getServiceStatus() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/status`, requestOptions).then(handleResponse);
}

function setServiceStatus(allowJoinChallenge, allowChallengeToStart, botsEnabled,disturbanceMessage) {
    const requestOptions = {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ allowJoinChallenge, allowChallengeToStart, botsEnabled, disturbanceMessage, displayOnOperational: false, displayOnNotOperational:true })
    };
    return fetch(`${config.url.BASE_URL}/api/management/status`, requestOptions).then(handleResponse);
}

function getRunningChallenges() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/running`, requestOptions).then(handleResponse);
}

function getFinishedChallenges() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/finished`, requestOptions).then(handleResponse);
}


function getAvailableChallenges() {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/available`, requestOptions).then(handleResponse);
}

function getChallenge(id) {
    const requestOptions = {
        method: 'GET',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/${id}`, requestOptions).then(handleResponse);
}

function cancelChallenge(jobId) {
    const requestOptions = {
        method: 'PUT',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
    };
    return fetch(`${config.url.BASE_URL}/api/management/challengejobs/${jobId}/cancel`, requestOptions).then(handleResponse);
}

function updateParticipantScore(id,participantId, score) {
    const requestOptions = {
        method: 'PUT',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        body: JSON.stringify({ score })
    };
    return fetch(`${config.url.BASE_URL}/api/management/challenges/${id}/participants/${participantId}/score`, requestOptions).then(handleResponse);
}

function login(username, password) {
    // console.log("Username=" + username);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };
    return fetch(`${config.url.BASE_URL}/api/account/authenticate`, requestOptions)
        .then(handleResponse)
        .then(console.log('Logging in: ', requestOptions))
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));

            return user;
        });
}


function errorCallout(error) {
    alert(error.message);
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('userInfo');
}

function displayError(errorCode) {
    console.log('There was an error: ', errorCode)
}






function handleResponse(response) {

    //console.log("Response=" + response);
    return response.text().then(text => {
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
                //location.reload isn't used when verifying credentials during login, it's for after the user is logged in if their authentication token becomes invalid for any reason 
                //which causes a 401 response to be returned by the api.If a 401 is returned logout() is called which removes the user from local storage, 
                //then location.reload(true) is called which refreshes the app to redirect the user back to the login page.
            }           
            else if (response.status === 503) {
                //Service unavailable, will be returned in case of maintenance
                const error = { errorCode: 503, message: 'Service is undergoing maintenance' };
                return Promise.reject(error);
            }

            const data = text && JSON.parse(text);
            if (typeof data !== 'undefined' && typeof data.message !== 'undefined') {
                return Promise.reject(data);
            }
            else if (typeof data !== 'undefined' && typeof data.title !== 'undefined') {
                const error = { errorCode: -1, message: typeof data.detail !== 'undefined' ? data.detail: data.title};
                return Promise.reject(error);
            }
            else {
                const error = { errorCode: -1, message: response.statusText };
                return Promise.reject(error);
            }
        }
        const data = text && JSON.parse(text);
        //console.log("data=" + JSON.stringify(data));
        //console.log("statusText=" + response.statusText);
        return data;
    });
}

function handleError(error) {
    if (error.message === 'Failed to fetch') {
        const msg = { errorCode: -1, message: 'Unable to connect to backend, please check you internet connection' };
        throw msg;
    }

    throw error;

}
